<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 81 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M52.107 64.764v3.743H45.66v7.092h-4.412V58.361h13.042v3.891h-8.63v2.512h6.448zM33.451 75.599h4.413V58.361h-4.413V75.6zm-13.41-4.925c.932.887 2.068 1.33 3.408 1.33 1.144 0 2.051-.271 2.721-.813v-5.64h4.438v7.66c-.687.755-1.676 1.403-2.967 1.945a11.266 11.266 0 0 1-4.192.788c-2.647 0-4.87-.837-6.668-2.512-1.782-1.69-2.672-3.842-2.672-6.452 0-2.626.898-4.777 2.697-6.452 1.78-1.674 4.053-2.512 6.815-2.512 1.781 0 3.448.411 5.001 1.232v4.161c-1.586-.87-3.146-1.305-4.683-1.305-1.552 0-2.827.46-3.824 1.38-.98.919-1.47 2.109-1.47 3.57 0 1.527.465 2.733 1.397 3.62zM70.34 93.326H15.874c-2.259 0-4.098-1.847-4.098-4.118v-4.762h50.775c2.354 0 4.262-1.915 4.262-4.28V54.197c0-2.365-1.908-4.281-4.262-4.281H11.776V10.625c0-2.264 1.84-4.112 4.098-4.112l37.494-.04v13.923c0 4.067 3.284 7.369 7.336 7.369l13.575-.04.153 61.483c0 2.271-1.834 4.118-4.093 4.118zM55.792 0H15.874C10.042 0 5.295 4.771 5.295 10.625v39.292H4.263C1.908 49.917 0 51.833 0 54.198v25.967c0 2.366 1.908 4.281 4.263 4.281h1.032v4.762c0 5.861 4.747 10.626 10.579 10.626h54.465c5.83 0 10.576-4.765 10.576-10.626v-64.06L55.792 0z"
      />
      <path
        d="M45.218 28.532a2.363 2.363 0 0 0-1.847.69l-3.056 3.093-7.793-7.828a2.364 2.364 0 0 0-1.682-.714 2.365 2.365 0 0 0-1.706.857L17.29 38.906a2.387 2.387 0 0 0 .3 3.352c.396.332.89.526 1.406.55h33.163a2.374 2.374 0 0 0 2.369-2.38c0-.514-.167-1.015-.474-1.427l-7.107-9.517a2.366 2.366 0 0 0-1.729-.952M42.684 14.255c2.616 0 4.737 2.13 4.737 4.76 0 2.627-2.12 4.758-4.737 4.758s-4.738-2.13-4.738-4.759c0-2.628 2.121-4.759 4.738-4.759"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-gif',
    props: {
      width: {
        type: [Number, String],
        default: 81
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
